import { InvoiceIssuerBank } from "./invoice-issuer-bank";

export class InvoiceIssuer{

    constructor(
        public name: string,
        public bankAccounts: InvoiceIssuerBank[],
        public postCode: string,
        public street: string,
        public vatNumber: string,
        public city: string,
        public id?: number
    ){}
}